import logo from './logo.svg';
import './App.css';
import RecipeReviewCard from './Card';
import BasicTabs from './Navigation';

function App() {
  return (
    <div className="App">
      <BasicTabs></BasicTabs>
    </div>
  );
}

export default App;
